import React from "react";

/**
 * BOOMM Monogram — uses the official brand asset.
 * - tone="espresso" → transparent PNG of the espresso B + gold fuse + spark (use on light surfaces)
 * - tone="linen"    → linen-on-transparent version with the gold preserved (use on dark surfaces)
 */
export const Monogram = ({ size = 96, className = "", tone = "espresso" }) => {
  const src =
    tone === "linen"
      ? "/boomm-monogram-linen.png"
      : "/boomm-monogram-transparent.png";
  return (
    <img
      src={src}
      alt="BOOMM Group monogram"
      style={{ width: size, height: size }}
      className={`select-none ${className}`}
      draggable="false"
    />
  );
};

export default Monogram;
